import { Card, CardHeader } from '@heroui/card';
import { useNavigate } from 'react-router-dom';

import { Songbook } from '@/core/db.ts';
import { createGradient } from '@/core/color.ts';

function SongbookComponent({ songbook }: { songbook: Songbook }) {
  const navigate = useNavigate();

  return (
    <Card
      isPressable
      className={`w-48 h-48 ${createGradient(songbook.color)} relative`}
      onPress={() => navigate(`/songbook/${songbook.id}`)}
    >
      <CardHeader>
        <h2 className="text-white font-medium text-large">{songbook.title}</h2>
      </CardHeader>
    </Card>
  );
}

export default SongbookComponent;
